{
  "tuto": "Sélectionnez l'action saut, puis, cliquez sur vos piouz pour les faire sauter vers la sortie.",
  "data": {
    "size": [
      592,
      424
    ],
    "tiles": [
      {
        "x": -63,
        "y": 148,
        "id": 134
      },
      {
        "x": 63,
        "y": 260,
        "id": 136
      },
      {
        "x": 571,
        "y": 294,
        "id": 135
      },
      {
        "x": 499,
        "y": 294,
        "id": 180
      },
      {
        "x": 522,
        "y": 235,
        "id": 135
      },
      {
        "x": 331,
        "y": 347,
        "id": 184
      },
      {
        "x": 169,
        "y": 323,
        "id": 142
      },
      {
        "x": 301,
        "y": 324,
        "id": 200
      },
      {
        "x": 303,
        "y": 334,
        "id": 206
      },
      {
        "x": 253,
        "y": 326,
        "id": 207
      },
      {
        "x": 338,
        "y": 355,
        "id": 207
      },
      {
        "x": 356,
        "y": 370,
        "id": 206
      },
      {
        "x": 261,
        "y": 302,
        "id": 90
      },
      {
        "x": 2,
        "y": 313,
        "id": 90
      },
      {
        "x": 544,
        "y": 326,
        "id": 90
      },
      {
        "x": 394,
        "y": 414,
        "id": 90
      },
      {
        "x": 220,
        "y": 367,
        "id": 90
      },
      {
        "x": 162,
        "y": 328,
        "id": 90
      },
      {
        "x": 33,
        "y": 296,
        "id": 88
      },
      {
        "x": 322,
        "y": 403,
        "id": 85
      },
      {
        "x": 315,
        "y": 393,
        "id": 85
      },
      {
        "x": 306,
        "y": 390,
        "id": 86
      },
      {
        "x": 284,
        "y": 390,
        "id": 84
      },
      {
        "x": 338,
        "y": 403,
        "id": 87
      },
      {
        "x": 376,
        "y": 401,
        "id": 87
      },
      {
        "x": 578,
        "y": 297,
        "id": 88
      },
      {
        "x": 359,
        "y": 296,
        "id": 199
      },
      {
        "x": 364,
        "y": 297,
        "id": 198
      },
      {
        "x": 440,
        "y": 318,
        "id": 192
      },
      {
        "x": 428,
        "y": 257,
        "id": 94
      }
    ],
    "platforms": [
      {
        "x": -208,
        "y": 286,
        "w": 532,
        "rid": 809,
        "rot": -168
      },
      {
        "x": 309,
        "y": 272,
        "w": 512,
        "rid": 145,
        "rot": 159
      },
      {
        "x": 225,
        "y": 278,
        "w": 220,
        "rid": 918,
        "rot": 177
      }
    ],
    "piou": [
      [
        109,
        331,
        1
      ],
      [
        125,
        341,
        1
      ],
      [
        143,
        343,
        1
      ],
      [
        93,
        333,
        1
      ]
    ],
    "out": [
      [
        352,
        249
      ]
    ],
    "action": [
      [
        0,
        40
      ],
      [
        1,
        0
      ],
      [
        2,
        0
      ],
      [
        3,
        0
      ],
      [
        4,
        0
      ],
      [
        5,
        0
      ],
      [
        6,
        0
      ],
      [
        0,
        0
      ],
      [
        0,
        0
      ],
      [
        0,
        0
      ]
    ],
    "caisse": [],
    "did": 0
  },
  "_piouz": 4,
  "_mode": 0,
  "_time": 23,
  "_id": 529,
  "_title": "tuto sauteur",
  "_playId": 1
}